import React from "react";
import { AppBar, Toolbar, Box, Container, Link as MuiLink } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import Typography from "../components/Typography";
import streetlogo from "../../assets/streetlogo.svg";
import AppBarSm from './AppBarSm'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LocalTaxiOutlinedIcon from '@mui/icons-material/LocalTaxiOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';

const rightLink = {
  fontSize: 16,
  ml: 3,
  textDecoration: "none",
};

const navItems = [
  { label: "Home", path: "/", icon:<HomeOutlinedIcon/> },
  { label: "Book online", path: process.env.REACT_APP_HAVANT_BOOKING, icon:<LocalTaxiOutlinedIcon/> },
  { label: "Terms and Conditions", path: "/terms-and-conditions", icon:<PolicyOutlinedIcon/>  },
];

function AppAppBar() {


  return (
    <div>
      <AppBar position="fixed">
        <Toolbar sx={{ justifyContent: "space-between", background: "white", color: "black" }}>
          <Container sx={{ display: "flex", alignItems:{xs:'center',lg:"center"}, justifyContent:{xs:'space-between',lg:"center"} }} >
            {/* Logo */}
            <Box sx={{py:1}}>
              
            <Link to="/">
              <img src={streetlogo} width={150} alt="Street Ride" />
            </Link>
            </Box>

            {/* Navigation Links */}
            <Box sx={{ flex: 1, display: { xs: 'none', lg: "flex" }, justifyContent: "flex-end", color: "black" }}>
              {navItems.map((item) => (
                <NavLink key={item.path} to={item.path} style={{ textDecoration: "none" }}>
                  {({ isActive }) => (
                    <MuiLink
                      variant="h6"
                      underline="none"
                      sx={{
                        ...rightLink,
                        color: isActive && !item.isHashRoute ? "primary.main" : "black", // Highlight active link
                        borderBottom: isActive && !item.isHashRoute ? "2px solid primary.main" : "none", // Underline active link
                        fontWeight: isActive && !item.isHashRoute ? 600 : 400,
                        pb: isActive && !item.isHashRoute ? "2px" : "0",
                      }}
                    >
                      <Typography variant="button" sx={{ fontSize: ".8rem", fontWeight: 500, letterSpacing: ".05rem" }}>
                        {item.label}
                      </Typography>
                    </MuiLink>
                  )}
                </NavLink>
              ))}
            </Box>
            <Box sx={{ display: { xs: 'block', lg: "none" } }}>
              <AppBarSm navItems={navItems} />
            </Box>
          </Container>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}

export default AppAppBar;
